/* eslint-disable no-restricted-globals */
import React, { useRef, useState, useCallback, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import moment from 'moment'
import * as Yup from 'yup'
import {
  FiMail,
  FiCalendar,
  FiSmartphone,
  FiArrowRight,
} from 'react-icons/fi'
import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import { ValorMascarar } from '../../utils/masks'
import calculaIdade from '../../utils/calculaIdade'
import InputHidden from '../../components/InputHidden'
import InputBox from '../../components/InputBox'
import Header from '../../components/Header'
import Button from '../../components/Button'
import Input from '../../components/Input'
import { Container, Content, Toggle } from './styles'
import { UserData, UserDetails } from '../../utils/interfaces'
import ModalBox from '../../components/Modal'
import Switch from 'react-switch'


const BemVindo: React.FC = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://d335luupugsy2.cloudfront.net/js/loader-scripts/5128ea05-7e88-4ac1-a471-de1126a37aae-loader.js";
    script.async = true;
    document.body.appendChild(script);
}, [])

  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [autorizacao, setAutorizacao] = useState<boolean>(false)

  const [contribValue, setContribValue] = useState(
    userDetails.contribuicaoBasica === null ||
      userDetails.contribuicaoBasica === undefined
      ? 10
      : userDetails.contribuicaoBasica,
  )
  const [dcrContribValue, setDcrContribValue] = useState(
    contribValue && contribValue !== 10
      ? ValorMascarar(`${contribValue.toFixed(2)}`)
      : '10,00',
  )

  const [aportValue, setAportValue] = useState(
    userDetails.aport === null || userDetails.aport === undefined
      ? 0
      : userDetails.aport,
  )
  const [dcrAportValue, setDcrAportValue] = useState(
    aportValue && aportValue !== 0
      ? ValorMascarar(`${aportValue.toFixed(2)}`)
      : '0,00',
  )

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [years, setYears] = useState(
    userDetails.years === null || userDetails.years === undefined
      ? '1'
      : userDetails.years.toString(),
  )
  const history = useHistory()
  const formRef = useRef<FormHandles>(null)
  const mudarContrib = useCallback(
    valor => {
      const v = valor.replaceAll('.', '').replace(',', '.').replace('R$ ', '')
      setContribValue(parseFloat(v))
      setDcrContribValue(ValorMascarar(valor))
    },
    [setContribValue],
  )
  const validarContrib = useCallback(
    valor => {
      const v = valor.replaceAll('.', '').replace(',', '.').replace('R$ ', '')
      if (isNaN(v)) {
        setContribValue(0)
        setDcrContribValue('0,00')
      } else {
        setContribValue(parseFloat(v))
        setDcrContribValue(ValorMascarar(valor))
      }
    },
    [setContribValue],
  )

  const mudarAport = useCallback(valor => {
    const v = valor.replaceAll('.', '').replace(',', '.').replace('R$ ', '')
    if (v <= 0) {
      setAportValue(0)
      setDcrAportValue('0,00')
    } else {
      setAportValue(parseFloat(v))
      setDcrAportValue(ValorMascarar(valor))
    }
  }, [])

  const validarAport = useCallback(valor => {
    const v = valor.replaceAll('.', '').replace(',', '.').replace('R$ ', '')
    setAportValue(parseFloat(v))
    setDcrAportValue(ValorMascarar(valor))
  }, [])


  const handleClick = useCallback(() => {
    formRef.current?.submitForm()
  }, [])

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          email: Yup.string()
            .required('E-mail é obrigatório')
            .email('Digite um e-mail válido'),
          phone: Yup.string()
            .max(15, 'Telefone inválido')
            .min(14, 'Telefone inválido')
            .required('Celular obrigatório'),
          birthdate: Yup.string()
            .required('Data de nascimento obrigatória')
            .test(
              '',
              'A data de nascimento não pode ser maior que hoje.',
              () =>
                moment() >
                  moment(data.birthdate.split('/').reverse().join('-')) ||
                data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                moment(
                  data.birthdate.split('/').reverse().join('-'),
                ).isValid() || data.birthdate === '',
            )
            .test(
              '',
              'Data de nascimento inválida',
              () =>
                calculaIdade(data.birthdate.split('/').reverse().join('-')) <=
                  115 || data.birthdate === '',
            ),
          aport: Yup.string().test(
            '',
            'Valor inválido.',
            () => aportValue <= 9000000000,
          ),
          years: Yup.number()
            .typeError('Digite o tempo para realizar a simulação')
            .min(1, 'Digite o tempo para realizar a simulação')
            .max(115, 'Tempo inválido.')
            .required('Digite o tempo para realizar a simulação'),
          contribution: Yup.string()
            .test(
              '',
              'O valor mínimo para contribuição é R$ 10,00',
              () => contribValue >= 10,
            )
            .test('', 'Valor inválido.', () => contribValue <= 9000000000),
        })

        await schema.validate(data, { abortEarly: false })

        setUserDetails({
          ...userDetails,
          contribuicaoBasica: contribValue,
          years: data.years * 1,
          aport: aportValue,
          age: calculaIdade(data.birthdate.split('/').reverse().join('-')),
        })

        setUserData({
          ...userData,
          phone: data.phone,
          email: data.email,
          birthdate: data.birthdate.split('/').reverse().join('-'),
        })

        history.push('/simulation')
      } catch (err) {
        formRef.current?.setErrors(getValidationErrors(err as any))
      }
    },
    [
      contribValue,
      history,
      setUserData,
      setUserDetails,
      userData,
      userDetails,
      aportValue,
    ],
  )
  
  const handleToggleChange = useCallback(() => {
    setAutorizacao(!autorizacao)
  }, [])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])


  return (
    <>
      <Header />
      <Container>
        <Form
          ref={formRef}
          onSubmit={handleSubmit}
          initialData={{
            email: userData.email,
            phone: userData.phone,
            birthdate:
              userData.birthdate === undefined
                ? ''
                : userData.birthdate.split('-').reverse().join('/'),
            years: userDetails.years,
            contribution: userDetails.contribuicaoBasica,
            aport: userDetails.aport,
          }}
        >
          <Content isActive>
            <h3>
              <strong>Olá!</strong> Que bom te ver por aqui! <br />
              Conte-nos um pouco sobre você
            </h3>
            <InputHidden name="contribution" type="hidden" />
            <input type="hidden" name="origem" value="Formulario - Adesao Plano Familia Optehub" />
            <Input
              icon={FiMail}
              name="email"
              type="email"
              placeholder="Seu e-mail pessoal"
            />
            <Input
              name="phone"
              mask="phone"
              prefix="+55 | "
              placeholder="Seu celular com DDD"
              icon={FiSmartphone}
            />
            <Input
              icon={FiCalendar}
              name="birthdate"
              mask="date"
              placeholder="Data de nascimento"
            />
          </Content>
          <InputBox
            name="aport"
            title="Deseja realizar um aporte inicial?"
            value={`R$ ${ValorMascarar(dcrAportValue)}`}
            onChange={e => mudarAport(e.target.value)}
            onBlur={e => validarAport(e.target.value)}
            smallText="O valor do aporte inicial só é considerado par afins de simulação"
          />
          <InputBox
            name="years"
            title="Por quantos anos deseja contribuir"
            placeholder="0"
            sufix="anos"
            value={years}
            onChange={e => setYears(e.target.value)}
          />
          <InputBox
            name="contribution"
            title="Qual valor mensal?"
            value={`R$ ${ValorMascarar(dcrContribValue)}`}
            onChange={e => mudarContrib(e.target.value)}
            onBlur={e => validarContrib(e.target.value)}
            smallText="Valor mensal recorrente"
          />
          <Toggle>
            <Switch
              onChange={setAutorizacao}
              checked={autorizacao}
              checkedIcon={false}
              uncheckedIcon={false}
              height={20}
              width={36}
              handleDiameter={18}
              offColor="#DEE3E1"
              offHandleColor="#fff"
              onHandleColor="#fff"
              onColor="#4CA585"
              name='LGPD'
            />
            <span>Declaro que li e aceito as condições gerais e autorizo o
                  compartilhamento dos meus dados e valores das movimentações
                  com a seguradora. Solicito que meus dados sejam apenas usados
                  para as finalidades informadas aqui, e sejam descartados
                  quando o contrato for extinto.</span>
          </Toggle>

          <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
            <strong>Tipo de contribuição</strong>
            <div>
              <h3>Contribuição mensal</h3>
              <p>
                Informe o quanto você deseja contribuir mensalmente para
                descobrir qual será sua renda no futuro.
              </p>
            </div>
            <div>
              <h3>Contribuição por renda</h3>
              <p>
                Informe a renda que você deseja ter no futuro para descobrir o
                quanto você precisa contribuir mensalmente para consegui-la.
              </p>
            </div>
          </ModalBox>
          <Button type="submit" color="green" onClick={handleClick} disabled={!autorizacao}>
            Próximos passos
            <div>
              <FiArrowRight />
            </div>
          </Button>
        </Form>
      </Container>
    </>
  )
}

export default BemVindo
